/**
 * Open/close state for the READ-ONLY "Calendar lookup table" viewer (Calendar
 * Year × Event × DC × PAW End × POG Complete). The data itself is preloaded
 * reference data (CALENDAR_LOOKUP) and is not editable — this store only tracks
 * whether the viewer dialog is open.
 */
import { create } from 'zustand'

interface CalendarLookupState {
  isOpen: boolean
  open: () => void
  close: () => void
}

export const useCalendarLookupStore = create<CalendarLookupState>(set => ({
  isOpen: false,
  open: () => set({ isOpen: true }),
  close: () => set({ isOpen: false }),
}))
